import { useMachineTypes } from "../api/queries/useMachineTypes"
import { MultiSelect } from "primereact/multiselect"

export default function MachineTypeMultiFilter(props) {
  const { data: machineTypes = [] } = useMachineTypes()

  return (
    <MultiSelect
      showClear={true}
      filter={true}
      options={machineTypes}
      placeholder={"Typ stroje"}
      optionLabel={"name"}
      optionValue={"uuid"}
      selectedItemsLabel={"{0} záznamů vybráno"}
      value={props.value}
      onChange={props.onChange}
    />
  )
}
